export enum CompanyType {
    Carrier = 1,
    Remittance = 2,
}

export const enumLabel = (value?: CompanyType) => {
    switch (value) {
        case CompanyType.Carrier:
            return 'Транспортная';
        case CompanyType.Remittance:
            return 'Переводы';
        default:
            return '';
    }
};
